export const getSearchQuery = (string) => {

    var query = "";
    if (string.length > 0) {
        const terms = string.split(" ");
        query = terms.join("%");
    }

    return query;
}